/* eslint-disable react-hooks/exhaustive-deps */
import {
  BaSeContainer,
  BaSeDialogContext,
  BaSeIcon,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';

import { tip1, tip3 } from '../../../../../utils/images';
import dica3 from '../../../assets/dica3.png';
import {
  ContainerImagem,
  ContainerOptionsWithCheck,
  ContentText,
} from './tutorial-styled';

const mapModulesColor = {
  1: {
    primaryColor: '#5c0936',
    secondaryColor: '#5c0936',
    tertiaryColor: '#175e8b',
  },
  2: {
    primaryColor: '#F5CE60',
    secondaryColor: '#5c0936',
    tertiaryColor: '#463B1B',
  },
  3: {
    primaryColor: '#4951ea',
    secondaryColor: '#4951ea',
    tertiaryColor: '#041143',
  },
};

export const useDialogsTutoriais = ({ moduleIdSelected, idInterview }) => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const settings = mapModulesColor[moduleIdSelected];

  const showDialogDica1 = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: '>',
          type: 'primary',
          color: settings?.primaryColor,
        },
      ],
      breakpointDelimiter: 'desktop',
      alignActions: 'center',
      size: 'large',
      title: '',
      dismissible: false,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      onChooseAction: (action) => {
        if (action === '>') {
          showDialogDica2();
        }
      },
      content: ({ closeModal, emitEvent }) => (
        <div>
          <header>
            <BaSeSmall1>1 de 3</BaSeSmall1>
          </header>
          <ContentText>
            <BaSeParagraph>
              Essa etapa consiste numa entrevista em que iremos conhecer um
              pouco mais sobre seu perfil empreendedor, para assim avaliar sua
              participação no seminário.
            </BaSeParagraph>
            <ContainerOptionsWithCheck>
              <BaSeIcon
                name="check"
                description="imagem de check"
                color={BaSeTheme.colors.defaultColors.black}
                size={20}
              />
              <BaSeParagraph>
                Reserve 1 hora, em um local tranquilo, onde não haja
                interrupções.
              </BaSeParagraph>
            </ContainerOptionsWithCheck>
            <ContainerOptionsWithCheck>
              <BaSeIcon
                name="check"
                description="imagem de check"
                color={BaSeTheme.colors.defaultColors.black}
                size={20}
              />
              <BaSeParagraph>
                Serão 5 perguntas, onde você pode responder por texto ou áudio.
              </BaSeParagraph>
            </ContainerOptionsWithCheck>
          </ContentText>
          <ContainerImagem>
            {' '}
            <img src={tip3} width={'90%'} alt="di a 1" />{' '}
          </ContainerImagem>
          {/* <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: 12,
            }}
          >
            <BaSeButton
              onClick={() => {
                showDialogDica2();
                closeModal();
              }}
              value=">"
              color={settings?.secondaryColor}
            />
          </div> */}
        </div>
      ),
    });
  }, [showModal]);

  const showDialogDica2 = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: '<',
          type: 'secondary',
          color: settings?.secondaryColor,
        },
        {
          action: '>',
          type: 'primary',
          color: settings?.secondaryColor,
        },
      ],
      breakpointDelimiter: 'desktopLarge',
      alignActions: 'center',
      size: 'large',
      title: '',
      dismissible: false,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      onChooseAction: (action) => {
        if (action === '>') {
          showDialogDica3();
        }
        if (action === '<') {
          showDialogDica1();
        }
      },
      content: ({ closeModal }) => (
        <BaSeContainer>
          <div>
            <header>
              <BaSeSmall1>2 de 3</BaSeSmall1>
            </header>
            <ContainerOptionsWithCheck>
              <BaSeIcon
                name="check"
                description="imagem de check"
                color={BaSeTheme.colors.defaultColors.black}
                size={20}
              />
              <BaSeParagraph>
                Ao iniciar a entrevista, fale ou escreva sempre em primeira
                pessoa (eu fiz, eu decidi, eu realizei, eu construí...), assim
                ficará claro as suas ações.
              </BaSeParagraph>
            </ContainerOptionsWithCheck>
            <ContainerOptionsWithCheck>
              <BaSeIcon
                name="check"
                description="imagem de check"
                color={BaSeTheme.colors.defaultColors.black}
                size={20}
              />
              <BaSeParagraph>
                Lembre-se do que você faz em seu dia a dia, da sua rotina e como
                você age. O texto é de sua autoria!
              </BaSeParagraph>
            </ContainerOptionsWithCheck>
            <ContainerImagem>
              {' '}
              <img src={tip1} width={'90%'} alt="di a 1" />{' '}
            </ContainerImagem>
          </div>
        </BaSeContainer>
      ),
    });
  }, [showModal]);

  const showDialogDica3 = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: '<',
          type: 'secondary',
          color: settings?.secondaryColor,
        },
        {
          action: 'Iniciar entrevista!',
          type: 'primary',
          color: settings?.secondaryColor,
        },
      ],
      breakpointDelimiter: 'desktopLarge',
      alignActions: 'center',
      size: 'large',
      title: '',
      dismissible: false,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      onChooseAction: (action) => {
        if (action === '<') {
          showDialogDica2();
        }
        // if (action === 'Iniciar entrevista!') {
        //   firstIteration(idInterview).then((response) => console.log(response));
        // }
      },
      content: ({ closeModal }) => (
        <BaSeContainer>
          <div>
            <header>
              <BaSeSmall1>3 de 3</BaSeSmall1>
            </header>
            <ContainerOptionsWithCheck>
              <BaSeIcon
                name="check"
                description="imagem de check"
                color={BaSeTheme.colors.defaultColors.black}
                size={20}
              />

              <BaSeParagraph>
                Para avançar com suas respostas, você irá precisar descrever uma
                ou mais situações até alcançar 120 palavras.
              </BaSeParagraph>
            </ContainerOptionsWithCheck>
            <ContainerOptionsWithCheck>
              <BaSeIcon
                name="check"
                description="imagem de check"
                color={BaSeTheme.colors.defaultColors.black}
                size={20}
              />
              <BaSeParagraph>
                Evite espaços em branco no meio do texto, tanto quanto
                caracteres sem utilidade importante (#,$,&,[,]) e/ou emojis.
              </BaSeParagraph>
            </ContainerOptionsWithCheck>

            <div>
              <BaSeParagraph>
                Tenha uma boa entrevista, estamos nessa juntos!
              </BaSeParagraph>
              <BaSeParagraph>
                A sua transformação também é nossa.
                <span aria-label="rocket and fire" role="img">
                  🚀🔥
                </span>
              </BaSeParagraph>
            </div>

            <ContainerImagem>
              {' '}
              <img src={dica3} width={'90%'} alt="di a 1" />{' '}
            </ContainerImagem>
          </div>
        </BaSeContainer>
      ),
    });
  }, [showModal]);

  return {
    showDialogDica1,
  };
};
